module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.5-247.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.5.md
// module id = 690
// module chunks = 274